import { EnvelopeIcon, FacebookLogoIcon, IconSize, TwitterLogoIcon } from '@lifechurch/react-ion';
import { FC } from 'react';
import SocialMediaButton from './SocialMediaButton';
import { useRouter } from 'next/dist/client/router';
import { getAbsoluteUrl } from '../lib/utils';

const EMAIL_SUBJECT = 'Check out this helpful article from Church Online!';

const SocialMediaBar: FC = () => {
  const router = useRouter();
  const hostname = getAbsoluteUrl();
  const url = `${hostname}${router.asPath}`;

  return (
    <div className='flex items-center'>
      <div className='mr-1 text-gray-50'>Share</div>
      <SocialMediaButton href={`https://www.facebook.com/sharer.php?u=${url}`}>
        <FacebookLogoIcon size={IconSize.XL} color='#1877F2' />
      </SocialMediaButton>
      <SocialMediaButton href={`https://twitter.com/intent/tweet?url=${url}`}>
        <TwitterLogoIcon size={IconSize.XL} color='#1DA1F2' />
      </SocialMediaButton>
      <SocialMediaButton href={`mailto:?subject=${EMAIL_SUBJECT}&body=${url}`}>
        <EnvelopeIcon size={IconSize.XL} color='#2993E5' />
      </SocialMediaButton>
    </div>
  );
};

export default SocialMediaBar;
